import { twSort } from 'atp-react-ui';

const useStyles = () => ({
  header: twSort`font-serif text-base font-medium text-secondary-dark md:text-2xl lg:text-3xl xl:text-4xl`,
  stepHeader: twSort`text-center font-sans text-xs font-bold uppercase text-orange-500 md:text-sm`,
  cardContainer: twSort`mt-4 rounded-lg bg-white shadow-md`,
  cardTableHeader: twSort`text-left font-sans font-bold`,
  cardTableContent: twSort`text-left font-sans font-normal`,
  cardBtn: twSort`w-full cursor-pointer border-none bg-transparent p-5`,
  list: twSort`font-ibm-plex-sans w-full list-none p-4 text-base font-bold text-secondary-dark md:text-lg`,
  smallHeader: twSort`text-xs uppercase`,
  subheader2: twSort`font-ibm-plex-sans text-base font-normal text-secondary-dark`,

  containTable: twSort`mt-2.5 rounded-xl rounded-bl-none bg-white px-4 py-3.5 shadow-card-primary-x-light`,
  table: twSort`font-ibm-plex-sans w-full text-xxs font-normal lg:text-sm`,
  customTd: twSort`border-t border-gray-200 p-1.5 leading-4 lg:p-2.5`,
  customTableText: twSort`font-caveat text-base font-medium text-secondary-dark md:text-lg`,
  tableHeader: twSort`mb-1.5 font-serif text-2xl font-medium tracking-x-wide text-secondary-dark`,
  disableCardBtn: twSort`pointer-events-none opacity-50`,
});

export default useStyles;
